import React from 'react';
import BaseComponent from './BaseComponent';
import Event from './Event';
import {connect} from 'react-redux';

export class PureEvents extends BaseComponent {
    render() {
        const {venue, events} = this.props;

        let filteredEvents = events.toList();
        if (venue) {
            filteredEvents = filteredEvents.filter(e => e.venue === venue.id);
        }

        return <div className="events">
            {filteredEvents.sortBy(e => e.start_time).map(event => <Event key={event.id} event={event} />)}
        </div>;
    }
}

function mapStateToProps({app}) {
    return {events: app.get('events')};
}

export default connect(mapStateToProps)(PureEvents);



/** WEBPACK FOOTER **
 ** ./src/components/Events.jsx
 **/